import { Component, Prop } from 'vue-property-decorator';
import { validateElevation } from '../../lib/prop-validators';
import ClInputBase from '../ClInputBase';

@Component({
  components: {
    ClInputBase
  }
})
export default class ClInput extends ClInputBase {
  @Prop({
    type: Boolean,
    default: false
  })
  readonly autoFocus!: boolean;

  @Prop({
    type: Number,
    default: 0,
    validator: validateElevation
  })
  public elevation!: number;

  @Prop({
    type: Number,
    default: 0,
    validator: validateElevation
  })
  public elevationOnFocus!: number;

  @Prop({
    type: Object,
    default: () => ({})
  })
  public componentProps!: object;

  private appliedElevation: number = this.elevation;
  private isFocused: boolean = false;

  public applyBlur(event: FocusEvent): void {
    this.$emit('blur', event);
    this.isFocused = false;
    this.appliedElevation = this.elevation;
  }

  public applyFocus(event: FocusEvent): void {
    this.$emit('focus', event);
    this.isFocused = true;
    if (!validateElevation(this.elevationOnFocus)) {
      return;
    }
    this.appliedElevation = this.elevationOnFocus;
  }
}
